<template>
	<div class="watch-readings-zones-modal">
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="zone.name" :subHeader="$t('headers.general.zone')">
			<google-map v-if="zones.length" :mode="mapMode" :zones="zones" :mapOptions="mapOptions"/>
		</modal-box>
	</div>
</template>

<script>
import { MAP_MODE_ZONE } from '@/utils/maps'
import GoogleMap from '@/components/maps/GoogleMap'
export default {
	components: {
		GoogleMap
	},
	data () {
		return {
			zone: null,
			mapMode: MAP_MODE_ZONE,
			mapOptions: {
				zoom: 16,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				zoomControl: false,
				draggable: false
			},
			modalBox: {
				open: false
			}
		}
	},
	computed: {
		zones () {
			return [this.zone]
		}
	},
	methods: {
		onModalBoxClose () {
			this.modalBox.open = false
			this.zone = null
		},
		onModalBoxOpen (zone) {
			this.zone = zone
			this.modalBox.open = true
		}
	},
	created () {
		this.$parent.$on('open-modal', this.onModalBoxOpen)
	},
	beforeDestroy () {
		this.$parent.$off('open-modal', this.onModalBoxOpen)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxMapZone.vue